import {SignupScreen} from "components/signup/signup-screen"
import Head from "next/head"
import {AppTheme} from "themes/app"

export default function Signup() {
  return (
    <AppTheme>
      <Head>
        <title>FocusTask | Sign up</title>
      </Head>

      <div style={{height: "100%"}} suppressHydrationWarning>
        {typeof window === "undefined" ? null : <SignupScreen />}
      </div>
    </AppTheme>
  )
}
